import React, { useEffect, useState } from 'react';
import './Timer.scss';

interface TimerProps {
  startTime: number;
  duration: number;
  onTimeout: () => void;
}

export function Timer({ startTime, duration, onTimeout }: TimerProps) {
  const [progress, setProgress] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);
      
      if (newProgress >= 100) {
        clearInterval(interval);
        onTimeout();
      }
    }, 100); // Update every 100ms for smooth animation
    
    return () => clearInterval(interval);
  }, [startTime, duration, onTimeout]);

  const radius = 12; // SVG circle radius
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (progress / 100) * circumference;

  return (
    <div className="timer">
      <svg viewBox="0 0 36 36" className="timer-circle">
        <path
          d="M18 6
            a 12 12 0 0 1 0 24
            a 12 12 0 0 1 0 -24"
          fill="none"
          stroke="#222"
          strokeWidth="6"
          className="timer-background"
        />
        <path
          d="M18 6
            a 12 12 0 0 1 0 24
            a 12 12 0 0 1 0 -24"
          fill="none"
          stroke="#eee"
          strokeWidth="6"
          className="timer-progress"
          strokeDasharray={`${circumference}, ${circumference}`}
          strokeDashoffset={dashOffset}
        />
      </svg>
    </div>
  );
}
